var _module_exports = "<ul class=\"nav editor-nav\" ng-transclude>\r\n    \r\n</ul>";;
var path = '/app/components/common/navigation-pane/navigationPane.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;